// extracted by mini-css-extract-plugin
export var chatHtmlText = "_od-2";
export var chatLink = "_od-0";
export var chatText = "_od-1";